import { WifiOff } from "lucide-react";
import { useConnectionStatus } from "@/hooks/useConnectionStatus";

export default function OfflineIndicator() {
  const online = useConnectionStatus();
  if (online) return null;
  return (
    <div
      data-testid="offline-indicator"
      className="fixed bottom-0 left-0 right-0 z-50 flex items-center justify-center gap-3 bg-[#CC3300] px-4 py-3 text-center font-ui text-xs font-bold uppercase tracking-[0.25em] text-white"
    >
      <WifiOff className="h-4 w-4" />
      Sin conexión — Los datos en vivo pueden estar desactualizados
    </div>
  );
}
